var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "page-wrap" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { list: _vm.Filtersearchlist, fromdata: _vm.formData },
        on: { Refresh: _vm.onHandleRefresh, search: _vm.onHandleSearch },
        scopedSlots: _vm._u(
          [
            _vm.topTip
              ? {
                  key: "left",
                  fn: function () {
                    return [
                      _vm.topTip
                        ? _c("span", { staticClass: "top-tip" }, [
                            _vm._v(_vm._s(_vm.topTip)),
                          ])
                        : _vm._e(),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "right",
              fn: function () {
                return undefined
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c(
        "section",
        { staticClass: "content-wrap" },
        [
          _c("table-list", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loadingData,
                expression: "loadingData",
              },
            ],
            attrs: { tableData: _vm.tableData },
            on: {
              "submit-form": _vm.submitForm,
              onHandleCoupon: _vm.onHandleCoupon,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.formData.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.formData.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.onHandleSizeChange,
              "current-change": _vm.onHandleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("coupon-config-dialog", {
        ref: "couponConfig",
        on: { "submit-form": _vm.submitForm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }